<!-- confirmation-dialog.component.html -->
<div class="dialog-wrappers">
  <div class="display-flex padding-dialog dialog-header">
    <div class="float-left">
      <div class="dialog-header-title">
        <h1 *ngIf="!data.okOnly">Confirmation</h1>
        <h1 *ngIf="data.okOnly">{{ title }}</h1>
      </div>
    </div>
    <div class="float-right">
      <!-- <span class="close-dialog" [mat-dialog-close]="true"><img src="../../../assets/icons/icon-close.png" alt="Close" width="16" /></span> -->
      &nbsp;
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="padding-dialog">{{ data.message }}</div>
  </mat-dialog-content>
  <mat-dialog-content class="dialog-content sub-text" *ngIf="data?.subText">
    <div class="padding-dialog">{{ data?.subText }}</div>
  </mat-dialog-content>
  <mat-dialog-content class="dialog-content" *ngIf="data?.confluenceUrl">
    <div class="padding-dialog confluence-link-section">
      <a [href]="data.confluenceUrl" target="_blank" rel="noopener noreferrer" class="confluence-link">{{
        data.confluenceUrl }}</a>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">

    <button *ngIf="!data.okOnly" mat-button [mat-dialog-close]="false" class="btn-white btn-dialog-cancel">No</button>
    <button *ngIf="!data.okOnly" mat-button [mat-dialog-close]="true" class="btn-red">Yes</button>
    <button *ngIf="data.okOnly" mat-button [mat-dialog-close]="true" class="btn-red" (click)="closeAllOverlays()">Okay</button>
  </mat-dialog-actions>
</div>